/**
 * Manage validators & associated error messages
 * @packageDocumentation
 * @module ValidationService
 */

import { PropertyConfig } from "../forms/propertyConfig";
import { ValidationError } from "../forms/validationError";
import { Validator } from "./validation.impl/validators/validator";

export const VALIDATION_SERVICE = "ValidationService";

export interface ValidationService {
    /**
     * Add/Set Validator within validators Map
     * If a validator with the same name is already present, 
     * - it will be overridden only if params.overrideIfAlreadyPresent is true
     * - a message will be output to console except if params.overrideIfAlreadyPresent is true or params.doNotDisplayErrorIfAlreadyPresent is true
     * @returns true if validator was added
     */
    addValidator(validatorName: string, validator: Validator, params?: { overrideIfAlreadyPresent?: boolean, doNotDisplayErrorIfAlreadyPresent?: boolean }): boolean;

    /** 
     * Check if a property meets associated validator constraint
     * @param allProperties of form
     * @param allPropertiesValues of form
     * @param propertiesToValidate list of props to validate, if undefined given, validate all props
     */
    validate(allProperties: Record<string, PropertyConfig>, allPropertiesValues: Record<string, unknown>, propertiesToValidate?: string[]): Record<string, ValidationError | undefined>;

    /**
     * @returns a default ValidationError
     */
    getDefaultValidationError(propertyLabel: string, isWarning?: boolean): ValidationError;
}
